module.exports = __webpack_public_path__ + "static/img/298_TO8_1936_og.f4a85e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/298_TO8_1936_og.jpg
// module id = 7DzZ
// module chunks = 0